import { AnalyticsStore, ContextStore, ExperimentStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { PropertyListing } from '@shared-ui/lodging-property-listing';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { getPropertySearchInput } from 'stores/adapters';
import { MultiItemStore } from 'stores/multi-item-store';
import { SearchCriteriaModel } from 'src/common/stores/models/search-criteria-model';
import { SearchResultsStore } from 'stores/search-results-store';
import { UIPageStore } from 'stores/ui-page-store';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLoader } from 'uitk-react-loader';

import { LodgingCardFieldsFragment } from '__generated__/api';
import useSecondaryFetchStatus from './use-secondary-fetch-status-hook';

export interface PropertyListingWrapperProps {
  context?: ContextStore;
  multiItem?: MultiItemStore;
  searchResults?: SearchResultsStore;
  experiment?: ExperimentStore;
  uiPage?: UIPageStore;
  currentHotel?: CurrentHotelStore;
  searchCriteria?: SearchCriteriaModel;
  analytics?: AnalyticsStore;
}

export const PropertyListingWrapper = inject(
  'context',
  'multiItem',
  'searchResults',
  'experiment',
  'uiPage',
  'currentHotel',
  'searchCriteria',
  'analytics'
)(({ analytics, context, multiItem, searchResults, experiment, uiPage, currentHotel, searchCriteria }: PropertyListingWrapperProps) => {
  if (!context || !searchResults?.searchCriteria) return null;
  const multiItemContext = multiItem?.multiItemContext || null;

  const showLoadingSpinner = useSecondaryFetchStatus({ searchResults, context, multiItem, uiPage, analytics, experiment });

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const {
    context: bexApiContext,
    returnPropertyType,
    ...rest
  } = getPropertySearchInput(
    context,
    searchResults?.searchCriteria,
    multiItemContext,
    false,
    undefined,
    experiment,
    searchResults?.pageData?.pageId
  );
  /* eslint-enable @typescript-eslint/no-unused-vars */

  const propertyListingInput = {
    ...rest,
    rooms: searchResults.searchCriteria.rooms,
  };

  const openDatepicker = () => {
    uiPage?.dispatchOpenNewDatePickerEvent();
  };

  const searchListings: any = searchResults?.propertyListings;

  // Temporarily passing the PWA search listings response to the shared UI component to avoid duplicating the
  // request for search listings on SRP. Once we migrate the lodging-pwa-property-search.graphql query to shared UI
  // this will be cleaned up.
  // The SRP Listings team is actively working on migrating the search query to shared UI!

  return (
    <>
      <PropertyListing
        inputs={propertyListingInput}
        propertySearchListingsPwa={searchListings}
        isLoadingPwa={searchResults?.isLoading}
        openDatePicker={openDatepicker}
        onClickCallback={(model: LodgingCardFieldsFragment) => {
          currentHotel?.setPropertyListingAsCurrentHotel(model);
        }}
        onHoverChanged={(id: string, hovered: boolean) => {
          searchCriteria?.setHighlightedPropertyId(hovered ? id : '');
        }}
      />
      {showLoadingSpinner && (
        <UitkLayoutFlex justifyContent="center">
          <UitkLayoutFlexItem>
            <UitkLoader />
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      )}
    </>
  );
});
